export default {
    it: {
        "base_label": "Data",
        "attachment-error": "Scegli una data"
    },
    en: {
        "base_label": "Date",
        "attachment-error": "Choose a date"
    }
}